import { Routes, Route } from 'react-router-dom';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import { hasAccessRight } from '../../utils/Functions';
import { IncomingDeferral } from './components/IncomingDeferral';
import { IncomingInvoices } from './components/IncomingInvoices';
import { LongTermIncomingInvoices } from './components/LongTermIncomingInvoices';
import { OutgoingInvoices } from './components/OutgoingInvoices';
import { IncomingKpis } from './components/IncomingKpis';
import { AgencyRevenueCampaigns } from './components/AgencyRevenueCampaigns';
import { AgencyMarginsCompanies } from './components/AgencyMarginsCompanies';

export default function ControllingRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.CONTROLLING) && (
                <>
                    <Route path="incoming-deferral" element={<IncomingDeferral />} />
                    <Route path="incoming-invoices" element={<IncomingInvoices />} />
                    <Route path="workspace-revenue" element={<OutgoingInvoices />} />
                    <Route path="long-term-incoming-invoices" element={<LongTermIncomingInvoices />} />
                    <Route path="deferral-list" element={<IncomingKpis />} />
                    <Route path="agency-revenue-campaings" element={<AgencyRevenueCampaigns />} />
                    <Route path="agency-margins-companies" element={<AgencyMarginsCompanies />} />
                </>
            )}
        </Routes>
    );
}
